import { Link } from 'react-router-dom';
import styled from 'styled-components';

export const ContainerPage = styled.div`
    padding: 1.5rem 2rem 3rem;
    color: var(--text-cor);
`;

export const Painel = styled.section`
    border-radius: var(--def-radius);
    background: var(--white);
    box-shadow: 0 0.2rem 0.8rem rgba(32, 33, 36, 0.12);
    overflow: hidden;
`;

export const Topo = styled.header`
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 1.2rem 2rem;
    padding: 2rem 2.4rem;
    border-bottom: 1px solid var(--bg-hover-light);

    h1 {
        margin: 0;
        font-size: var(--size-h4);
        font-weight: 600;
        color: var(--btn-admin-icone);
    }

    p {
        margin: 0.4rem 0 0;
        font-size: var(--size-span);
    }

    input {
        height: 3.6rem;
        width: 24rem;
        margin-left: auto;
        padding: 0 1.2rem;
        border: 1px solid var(--bg-hover-light);
        border-radius: 0.6rem;
        font-size: var(--size-span);
        color: var(--text-cor);
        background: var(--white);

        &::placeholder {
            color: var(--gray);
        }

        &:focus-visible {
            outline: 2px solid var(--btn-admin-icone);
            outline-offset: 1px;
        }
    }

    @media (max-width: 768px) {
        input {
            width: 100%;
            margin-left: 0;
        }
    }
`;

export const Lista = styled.ul`
    margin: 0;
    padding: 0;
    list-style: none;

    li {
        display: flex;
        align-items: center;
        gap: 1.6rem;
        padding: 1.6rem 2.4rem;

        & + li {
            border-top: 1px solid var(--bg-hover-light);
        }
    }

    .info {
        flex: 1;
        min-width: 0;
    }

    strong {
        display: block;
        font-size: var(--size-p);
        font-weight: 600;
        color: var(--brown);
        overflow-wrap: anywhere;
    }

    small {
        display: block;
        margin-top: 0.2rem;
        font-size: 1.3rem;
        font-variant-numeric: tabular-nums;
    }

    .total {
        padding: 0.4rem 1.2rem;
        border-radius: 2rem;
        font-size: 1.3rem;
        font-weight: 600;
        color: var(--btn-admin-icone);
        background: var(--btn-bg-small-interest);
    }

    @media (max-width: 560px) {
        li {
            flex-wrap: wrap;
        }
    }
`;

export const BotaoGerenciar = styled(Link)`
    display: inline-flex;
    align-items: center;
    height: 3.6rem;
    padding: 0 1.8rem;
    border-radius: 0.6rem;
    font-size: var(--size-span);
    font-weight: 600;
    font-style: normal;
    white-space: nowrap;
    text-decoration: none;
    color: var(--white);
    background: var(--btn-admin-icone);
    transition: background-color 0.15s ease-out;

    &:hover {
        color: var(--white);
        background: var(--btn-underline-cor);
    }

    &:focus-visible {
        outline: 2px solid var(--btn-admin-icone);
        outline-offset: 2px;
    }
`;

export const Estado = styled.p`
    margin: 0;
    padding: 4rem 2.4rem;
    text-align: center;
    font-size: var(--size-span);
`;
